import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
import DevTools from '../containers/DevTools/DevTools';
import { persistState } from 'redux-devtools';
import {inBrowser } from '../../utils';
import { createEpicMiddleware } from 'redux-observable';
import { createResponsiveStoreEnhancer } from 'redux-responsive';
import { rootReducer, rootEpic } from '../models';

function getSessionKey() {
		// By default we try to read the key from ?debug_session=<key> in the address bar
		const matches = window.location.href.match(/[?&]debug_session=([^&#]+)\b/);
		return (matches && matches.length > 0) ? matches[1] : null;
}

declare var window: any;
export default function configureStore({initialState={}, middleware=([] as any)}) {
	const BROWSER_DEBUG = (inBrowser() && process.env.NODE_ENV !== 'production');
	const enhancers = [createResponsiveStoreEnhancer({calculateInitialState: false}) as any]
	const devToolsExtension = (BROWSER_DEBUG && window.devToolsExtension) ? window.devToolsExtension() : DevTools.instrument()
	const debugEnhancers = BROWSER_DEBUG ? [devToolsExtension, persistState(getSessionKey())] : []

	const epicMiddleware = createEpicMiddleware(rootEpic);
	const extraMiddleware = [
		epicMiddleware,
		thunk,
		createLogger({
			predicate: () => inBrowser() && process.env.NODE_ENV !== 'production',
			collapsed: true
		})
	];
	const appliedMiddleware = applyMiddleware(...middleware, ...extraMiddleware)
	return createStore(
		rootReducer,
		initialState,
		(compose as any)(appliedMiddleware, ...enhancers, ...debugEnhancers)
	);
}



// WEBPACK FOOTER //
// ./src/app/store/configureStore.ts